import _asyncToGenerator from "/Users/yinpeng/Sites/gitlab/layaair-pro-web/performance/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/Users/yinpeng/Sites/gitlab/layaair-pro-web/performance/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "regenerator-runtime/runtime.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getUrl } from '@/utils/tool';
import { mapGetters } from 'vuex';
import { parseTime } from '@/utils';
import UploadImg from '@/components/UploadImg';
import { cateArr } from '@/config/project';
import { projectRule } from '@/utils/rule';
import { projectList, createProject as _createProject } from '@/api/project';
import { informLateList, informHistoryList, informErrorList } from '@/api/report';
export default {
  name: 'Home',
  components: {
    UploadImg: UploadImg
  },
  data: function data() {
    return {
      dialogCreate: false,
      reportList: {
        newReport: [],
        recentReport: [],
        errReport: []
      },
      arrowOpen: {
        new: true,
        recent: true,
        err: true
      },
      projectList: [],
      dialogData: {
        root_cate: 2,
        second_cate: 3
      },
      cateMap: {},
      projectRule: projectRule
    };
  },
  computed: _objectSpread({}, mapGetters(['isVip', 'performanceCount'])),
  created: function created() {
    for (var i = 0; i < cateArr.length; i++) {
      this.cateMap[cateArr[i].id] = cateArr[i]; // this.cateMap[cateArr[i].id].childMap = {}
      // for (let j = 0; j < cateArr[i].children.length; j++) {
      //   this.cateMap[cateArr[i].id].childMap[cateArr[i].children[j].id] = cateArr[i].children[j]
      // }
    }

    console.log('cateMap', this.cateMap);
    this.getReportList();
    this.getProjectList();
  },
  methods: {
    getUrl: getUrl,
    parseTime: parseTime,
    getReportList: function getReportList() {
      var _this = this;

      var query = {
        page: 0,
        pagesize: 10
      };
      informLateList(query).then(function (res) {
        _this.reportList.newReport = res.data.data.list;
      });
      informHistoryList(query).then(function (res) {
        _this.reportList.recentReport = res.data.data.list;
      });
      informErrorList(query).then(function (res) {
        _this.reportList.errReport = res.data.data.list;
      }); // this.reportList.newReport = [
      //   {
      //     'report_id': 1,
      //     'report_name': '报告名称1'
      //   },
      //   {
      //     'report_id': 2,
      //     'report_name': '报告名称2'
      //   }
      // ]
      // this.reportList.recentReport = [
      //   {
      //     'report_id': 3,
      //     'report_name': '报告名称3'
      //   },
      //   {
      //     'report_id': 4,
      //     'report_name': '报告名称4'
      //   }
      // ]
      // this.reportList.errReport = [
      //   {
      //     'report_id': 5,
      //     'report_name': '报告名称5'
      //   },
      //   {
      //     'report_id': 6,
      //     'report_name': '报告名称6'
      //   }
      // ]
    },
    getProjectList: function getProjectList() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.loading = true;
                _context.next = 3;
                return projectList({
                  page: 0,
                  pagesize: 10
                });

              case 3:
                res = _context.sent;
                _this2.projectList = res.data.data.list;
                _this2.loading = false;

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    changeReporetList: function changeReporetList(key) {
      this.arrowOpen[key] = !this.arrowOpen[key];
    },
    dialogShow: function dialogShow() {
      var _this3 = this;

      this.dialogData = {
        root_cate: 2,
        second_cate: 3
      };
      this.$nextTick(function () {
        _this3.$refs['createForm'].clearValidate();
      });
      this.dialogCreate = true;
    },
    changeRootCate: function changeRootCate(rootCate) {
      this.dialogData.second_cate = this.cateMap[rootCate].children[0].id;
    },
    createProject: function createProject() {
      var _this4 = this;

      // this.$refs['createForm'].clearValidate()
      this.$refs['createForm'].validate( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(valid) {
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (!valid) {
                    _context2.next = 5;
                    break;
                  }

                  _context2.next = 3;
                  return _createProject(_this4.dialogData);

                case 3:
                  // 提交表单的逻辑
                  _this4.getProjectList();

                  _this4.dialogCreate = false;

                case 5:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    gotoPay: function gotoPay() {
      this.$router.push({
        name: 'PayCount'
      });
    },
    gotoProject: function gotoProject(id) {
      this.$router.push({
        params: {
          id: id
        },
        name: 'ProjectIndex'
      });
    },
    gotoReport: function gotoReport(projectId, reportId) {
      this.$router.push({
        params: {
          projectId: projectId,
          reportId: reportId
        },
        name: 'ReportGeneral'
      });
    }
  }
};